import ajax from "../utils/request";
const landPageApi = {
  /******************* 域名配置**********************8*/
  // 域名配置请求列表
  getLangPageList(params) {
    return ajax({
      url: "/webplt/list",
      type: "get",
      params: params,
    });
  },
  // 新增域名配置
  addLandPage(params) {
    return ajax({
      url: "/webplt/add",
      type: "post",
      params: params,
    });
  },
  // 删除域名配置
  deleteLandPage(params) {
    return ajax({
      url: "/webplt/del",
      type: "delete",
      params: params,
    });
  },
  // 编辑落地页配置
  editLandPage(params) {
    return ajax({
      url: "/webplt/update",
      type: "post",
      params: params,
    });
  },
  /********************* 落地页配置************************/
  // 获取落地页配置
  getLdyList(params) {
    return ajax({
      url: "/ldy/cfg",
      type: "get",
      params: params,
    });
  },
  //编辑
  updateLdy(params) {
    return ajax({
      url: "/ldy/update",
      type: "post",
      params,
    });
  },

  // // 添加按钮状态
  // addSwitchFlag(params) {
  //   return ajax({
  //     url: '/switch/add',
  //     type: 'post',
  //     params: params
  //   });
  // },
  // // 获取开关
  // getSwitchList(params) {
  //   return ajax({
  //     url: '/switch/list',
  //     type: 'get',
  //     params: params
  //   });
  // }
  // // 删除开关
  // deleteSwitch(params) {
  //   return ajax({
  //     url: '/switch/del',
  //     type: 'delete',
  //     params: params
  //   });
  // },
  // // 获取开关
  // getSwitchList(params) {
  //   return ajax({
  //     url: '/switch/list',
  //     type: 'get',
  //     params: params
  //   });
  // }
};

export default landPageApi;
